import React from 'react';
import { LadderPopup } from 'components/LadderPopup';
import JoinChatPopup from 'react/chat/JoinChatPopup';
import { __ } from 'i18n/index';

// "+ Browse Rooms": the create/join chat room popup. Picking a room or
// creating one closes it.
export default function openAddChannelPopup() {
	const popup = LadderPopup.create(
		(
			<JoinChatPopup
				dismiss={() => {
					popup.dismiss(__('Joining?!'));
				}}
			/>
		),
		__('Create/Join a Chat Group'),
		{
			buttons: [{
				text: __('Cancel'),
				dismiss: true
			}]
		}
	);
}
